const token='6b28477a1419a8588f8455695efe6d1a3760f8e0c914be70a80513bc04530d9bf356b49211ed71f2fb837a23aa5ede00a868ade5916381830f3023b39e8422e07cd7b57f952de6caf7e8fda60f11095e525db7ba2896a5eb48183873477e06b813841c234400174f3b61981e29a3fb805415bb30ab65b9d9710959464fc90ac9';

export const generateToken =()=>{
    return token;
}